import {createAction, createAsyncThunk} from '@reduxjs/toolkit';

import {getSeries} from '@explorer/api/mosaics';

export const fetchSeriesRequest = createAsyncThunk('series/fetch', () => {
  const allSeries = [];

  const onEach = series => {
    allSeries.push(...series);
  };

  return getSeries(onEach).then(() => {
    return allSeries;
  });
});

export const selectSeries = createAction('series/select');

export const setActiveSeriesId = createAction('series/setActive');

export const setIntervals = createAction('series/setIntervals');
